import { css } from '@emotion/react';
import { ProColors } from '../../aura';

export type ProgressTemplateProps = {
  progress: number;
};

export function ProgressTemplate(props: ProgressTemplateProps): JSX.Element {
  const { progress } = props;
  return (
    <div
      css={css({
        height: 4,
        width: '100%',
        backgroundColor: ProColors.navy[300],
      })}
    >
      <div
        css={css({
          height: 4,
          width: `${progress}%`,
          backgroundColor: ProColors.teal[600],
          borderRadius: '0 2px 2px 0',
          transitionDuration: '400ms',
          transitionTimingFunction: 'ease-in-out',
        })}
      />
    </div>
  );
}
